export { default } from './BuildingAmenities';
